<div class="create_container">
    <div class="header">
        <h4 class="title3 text-ink_darker">Create new event</h4>
        <app-buttons color="blue" label="create" (btnClick)="createEvent()"></app-buttons>
    </div>
</div>